/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `skill` - skill * `competence` - competence * `literacy` - literacy
 */
export type ClassificationItemKindEnum = 'skill' | 'competence' | 'literacy';

export const ClassificationItemKindEnum = {
    Skill: 'skill' as ClassificationItemKindEnum,
    Competence: 'competence' as ClassificationItemKindEnum,
    Literacy: 'literacy' as ClassificationItemKindEnum
};